/** Kanban columns for business accounts (matches product copy). */
export const AccountStage = {
  NEW_ACCOUNT: "New Account",
  ACTIVE_CLIENT: "Active Client",
  CHURNED: "Churned",
};

export const AccountStageOrder = [
  AccountStage.NEW_ACCOUNT,
  AccountStage.ACTIVE_CLIENT,
  AccountStage.CHURNED,
];

/** Card background tint per column */
export const AccountStageColors = {
  [AccountStage.NEW_ACCOUNT]: "#ffffff",
  [AccountStage.ACTIVE_CLIENT]: "#e8f4fc",
  [AccountStage.CHURNED]: "#fce8ec",
};

const norm = (v) => String(v ?? "").trim().toLowerCase();

/** API enum for PATCH /update-account-stage */
export const AccountStageApi = {
  NEW_ACCOUNT: 1,
  ACTIVE_CLIENT: 2,
  CHURNED: 3,
};

export function accountStageToApiValue(stage) {
  if (stage === AccountStage.ACTIVE_CLIENT) return AccountStageApi.ACTIVE_CLIENT;
  if (stage === AccountStage.CHURNED) return AccountStageApi.CHURNED;
  return AccountStageApi.NEW_ACCOUNT;
}

export function apiStageToAccountStage(stage) {
  const n = typeof stage === "number" ? stage : Number(stage);
  if (n === AccountStageApi.ACTIVE_CLIENT) return AccountStage.ACTIVE_CLIENT;
  if (n === AccountStageApi.CHURNED) return AccountStage.CHURNED;
  return AccountStage.NEW_ACCOUNT;
}

/**
 * Map API / stored value to one of AccountStage (defaults to New Account).
 */
export function mapRawStageToAccountStage(raw) {
  if (typeof raw === "number" || (typeof raw === "string" && /^\d+$/.test(raw.trim()))) {
    return apiStageToAccountStage(raw);
  }
  const s = norm(raw).replace(/_/g, " ");
  if (!s) return AccountStage.NEW_ACCOUNT;
  if (s.includes("churn")) return AccountStage.CHURNED;
  if (s.includes("active")) return AccountStage.ACTIVE_CLIENT;
  if (s.includes("new")) return AccountStage.NEW_ACCOUNT;
  if (raw === AccountStage.NEW_ACCOUNT) return AccountStage.NEW_ACCOUNT;
  if (raw === AccountStage.ACTIVE_CLIENT) return AccountStage.ACTIVE_CLIENT;
  if (raw === AccountStage.CHURNED) return AccountStage.CHURNED;
  return AccountStage.NEW_ACCOUNT;
}
